module.exports = function (fox) {
	'use strict';
	fox.registerWidget('Page_CCPA_MC', {
		configure() {
			this.registerOptions('', {
				widgets: {
					popup: {
						widget: 'PopupWidget',
						useUiPosition: true,
						dialog: {
							title: 'California Consumer Privacy form',
							width: '550px',
							dialogClass: 'dlg-amc dark-overlay cookie-consent-popup ccpa-form'
						},
						widgets: {
							content: {
								template: 'ccpa_form_mc',
								widget: 'CCPR_Form',
							}
						}
					},
					popupSuccess: {
						widget: 'PopupWidget',
						useUiPosition: true,
						dialog: {
							title: 'Success',
							width: '340px',
							dialogClass: 'dlg-amc dark-overlay cookie-consent-popup ccpa-form'
						},
						widgets: {
							content: {
								widget: 'Widget',
								template: 'ccpa_success_mc',
								handleDom: {
									closePopup: {
										target: '#success',
										event: 'click',
										callback : '@parent @parent:successHide'
										
									}
								}
							}
						}
					}
				},
				handleWom: {
					success: {
						widget: '#popup #content',
						event: 'form_submit_success',
						callback: 'hidePopup',
					}
				}
			});
			this.callParent('configure', arguments);
		},
		successHide(){
			this.wom1('#popupSuccess').hide();
		},
		showPopup() {
				this.wom1('#popup').show();
		},
		hidePopup() {
			this.wom1('#popup').hide();
			this.wom1('#popupSuccess').show();
		},
	}, 'Page_CCPA');
};



// WEBPACK FOOTER //
// ./widget/ccpa.es.js